import React from 'react';
import PropTypes from 'prop-types';

// Models
import Contract from 'models/Contract';

// Components
import Box from 'ui/Box';
import Heading from 'ui/Heading';
import Text from 'ui/Text';
import Datalist from 'ui/DataList';

export const ContractInfo = ({ contract }) => {
  const data = contract.contractPeriod
    ? [
        {
          id: 'contractNumber',
          label: 'Contract number:',
          value: contract.contractNumber,
        },
        {
          id: 'lessorName',
          label: 'Lessor/Vendor name:',
          value: contract.lessorName,
        },
        {
          id: 'vendorCode',
          label: 'Vendor code:',
          value: contract.vendorCode,
          break: true,
        },
        {
          id: 'contractPeriod',
          label: 'Contract period:',
          value: contract.contractPeriod,
        },
        {
          id: 'status',
          label: 'Status:',
          value: (
            <Text id="status" color={contract.statusColor}>
              ● {contract.status}
            </Text>
          ),
        },
        {
          id: 'paymentTerm',
          label: 'Payment term:',
          value: contract.paymentTerm,
        },
        {
          id: 'current-rate',
          label: 'Current rate:',
          value: contract.paymentRate,
        },
        {
          id: 'paymentMethod',
          label: 'Payment method:',
          value: contract.paymentMethod,
          break: true,
        },
        {
          id: 'businessPartnerCode',
          label: 'Business partner code:',
          value: contract.businessPartnerCode,
        },
        {
          id: 'companyCode',
          label: 'Company code:',
          value: contract.companyCode,
        },
        {
          id: 'securityDeposit',
          label: 'Security deposit:',
          value: contract.securityDeposit,
        },
      ]
    : [
        {
          id: 'contractNumber',
          label: 'Contract number:',
          value: contract.contractNumber,
        },
        {
          id: 'lessorName',
          label: 'Lessor/Vendor name:',
          value: contract.lessorName,
        },
        {
          id: 'vendorCode',
          label: 'Vendor code:',
          value: contract.vendorCode,
          break: true,
        },
        {
          id: 'status',
          label: 'Status:',
          value: (
            <Text id="status" color={contract.statusColor}>
              ● {contract.status}
            </Text>
          ),
        },
        {
          id: 'paymentTerm',
          label: 'Payment term:',
          value: contract.paymentTerm,
        },
        {
          id: 'current-rate',
          label: 'Current rate:',
          value: contract.paymentRate,
        },
        {
          id: 'paymentMethod',
          label: 'Payment method:',
          value: contract.paymentMethod,
          break: true,
        },
        {
          id: 'businessPartnerCode',
          label: 'Business partner code:',
          value: contract.businessPartnerCode,
        },
        {
          id: 'companyCode',
          label: 'Company code:',
          value: contract.companyCode,
        },
        {
          id: 'securityDeposit',
          label: 'Security deposit:',
          value: contract.securityDeposit,
        },
      ];
  return (
    <>
      <Heading size={30} paddingBottom={15} paddingTop={0}>
        Contract #{contract.contractNumber}
      </Heading>

      <Box style={{ borderRadius: 0 }}>
        <Datalist data={data} narrow={true} />
      </Box>
    </>
  );
};

ContractInfo.propTypes = {
  contract: PropTypes.instanceOf(Contract),
};

ContractInfo.defaultProps = {
  contract: new Contract(),
};

export default ContractInfo;
